export const WAIT = 'wait';
export const END_WAIT = 'end_wait';
export const RENDER_MODAL = 'render_modal';
export const CLEAR_MODAL = 'clear_modal';
export const ADD_MESSAGE = 'add_message';
export const REMOVE_MESSAGE = 'remove_message';
export const CLEAR_MESSAGES = 'clear_messages';
export const RESET_STATE = 'reset_state';
export const SET_SERVER_ALIAS = 'set_server_alias';
export const SET_SERVER_VERSION = 'set_server_version';
export const SET_PANEL_DISPLAY = 'set_panel_display';
export const SET_DEBUG_OVERLAY_ENABLED = 'set_debug_overlay_enabled';
export const SET_PRIMARY_PANEL_VIEW = 'set_primary_panel_view';
export const SET_SECONDARY_PANEL_VIEW = 'set_secondary_panel_view';
export const CLEAR_PRIMARY_PANEL = 'clear_primary_panel';
export const CLEAR_SECONDARY_PANEL = 'clear_secondary_panel';
export const MOUNT_VIEW = 'mount_view';
export const SET_SESSION_TIMEOUT = 'set_session_timeout';
export const SET_SESSION_WARNING_TIMEOUT = 'set_session_warning_timeout';
export const WAPI_REFETCH = 'wapi_refecth';
export const SET_POSTLOGIN_SCREEN_ROUTE = 'set_postlogin_screen_route';

export interface Message {
  id: number,
  type: string,
  text: string,
  timeout: number,
}

export interface PayloadAction<T> {
  type: string,
  payload: T
}
